import {
  type ContentColorKeys,
  convertHexToContentColorKeys,
} from '@banhala/ui-kit';

type ParsedCtaDescription = {
  highlight?: {
    text: string;
    color: ContentColorKeys;
  };
  text: string;
};

export const parseCtaDescription = (
  html: string,
): ParsedCtaDescription | undefined => {
  if (!html) return undefined;

  // Match pattern: <strong><font color='#FF5160'>text</font></strong> remaining text
  const strongFontRegex =
    /<strong><font color=['"]([^'"]+)['"]>([^<]+)<\/font><\/strong>\s*(.+)/;
  const match = html.match(strongFontRegex);

  if (match) {
    const [, color, highlightText, remainingText] = match;
    return {
      highlight: {
        text: highlightText,
        color: convertHexToContentColorKeys(color) ?? 'content_primary',
      },
      text: remainingText,
    };
  }

  // If no match, strip all HTML tags and return plain text
  const plainText = html.replace(/<[^>]*>/g, '');
  return {
    text: plainText,
  };
};
